import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface RetainingWallsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const RetainingWalls: React.FC<RetainingWallsProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [retainingWalls, set_retainingWalls] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Foundations']?.['Retaining Walls'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Foundations': { ...b.values?.['Foundations'], 'Retaining Walls': v } } })
    );
    const label = 'Retaining Walls';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(retainingWalls)}
                />
            ) : (
                <MoneyBox
                    id={'retainingWalls'}
                    allowNegative={false}
                    value={retainingWalls}
                    onChange={(value) => set_retainingWalls(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
